import { AutoReload } from '../../views/ts/components/AutoReload';
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { Carousel } from '../../views/twig/modules/carousel';
import { Menu } from '../../views/twig/components/Menu';
import { TextImage } from '../../views/twig/modules/text_image';
import { Video } from '../twig/modules/video';
import { Collapse } from './components/Collapse';
(new AutoReload()).init();
(new LazyLoader()).init();
(new Menu()).init();
(new Carousel()).init();
(new TextImage()).init();
(new Video()).init();
(new Collapse()).init();
